import React from "react";
import { Box, Heading, Text, Container } from "@chakra-ui/react";

const Sitemap = () => {
  return (
    <Box>
      <Box
        pt="130px" // Adjust padding top to be below both navbars
        minHeight="100vh"
        bg="gray.100" // Attractive background color
        textAlign="center"
      >
        <Container maxW="container.md" py={10}>
          <Heading mb={4}>Sitemap Page</Heading>
          <Text fontSize="lg">
            This is the Sitemap page. Content coming soon!
          </Text>
        </Container>
      </Box>
    </Box>
  );
}

export default Sitemap; 